import { useNavigate } from "react-router-dom"
import BaseSection from "../../../../components/elements/BaseSection"
import { BillGet } from "../../../../data/Types"
import { BillRow } from "../BillRow"
import { Navigation } from "../../../../api/constants"
import BaseSectionHeadline from "../../../../components/elements/BaseSectionHeadline"
import { ReactComponent as PLUS } from "../../../../assets/PlusInCircleIcon.svg"
import { useContext } from "react"
import { ModalContext } from "../../../../components/contexts/ModalContext"

type MajorOrderDetailBillListType = {
    id: string
    bills: BillGet[]
}

export default function MajorOrderDetailBillList(props: MajorOrderDetailBillListType) {
    const navigate = useNavigate()
    const modalCon = useContext(ModalContext)
    return (
        <BaseSection classProps="min-h-[12rem]">
            <BaseSectionHeadline
                label="Rechnungen"
                classProps="!mb-0"
                icon={
                    <PLUS
                        className="w-6 h-6 cursor-pointer"
                        onClick={() => {
                            navigate(Navigation.BILL_ADD + `?mid=${props.id}`)
                            modalCon?.trigger(1)
                        }}
                    />
                }
            />
            {props.bills.length === 0 ? (
                <p className="text-sm text-gray-300">Für diesen Auftrag wurden noch keine Rechnungen erstellt.</p>
            ) : (
                props.bills.map((item) => <BillRow item={item} navigate={() => navigate("/buchhaltung/rechnung/" + item._id)} />)
            )}
        </BaseSection>
    )
}
